import type { AppetiteParentRegisterResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetAppetitesByRiskIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAppetitesByRiskIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetAppetitesByRiskIdArgs = {
  riskId: string;
};

/**
 * Maps TRPC appetite data to match the GraphQL query structure
 */
function mapTrpcAppetitesToGraphQL(
  trpcData: AppetiteParentRegisterResponseRow[]
): GetAppetitesByRiskIdQuery {
  return {
    appetite_parent: trpcData,
  };
}

export const useGetAppetitesByRiskId = createQueryHook<
  UseGetAppetitesByRiskIdArgs,
  AppetiteParentRegisterResponseRow[],
  GetAppetitesByRiskIdQuery
>({
  trpcQueryOptions: (trpc, { riskId }) =>
    trpc.frontend.appetite.appetitesByRiskId.queryOptions({ riskId }),
  mapTrpcDataToGraphQL: mapTrpcAppetitesToGraphQL,
  graphqlDocument: GetAppetitesByRiskIdDocument,
  graphqlVariables: ({ riskId }) => ({ riskId }),
});
